import controller from './home.controller';
import templateT1 from './templates/home-t1.view.html';
import templateAD from './templates/home-adaptative.html';

let HomeComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];


function changeTemplate(SessionService) {
  let response = SessionService.get('components');
  if(__env.adaptative){
    return templateAD;
  }else{
    return templateT1
  }
}

export default HomeComponent;



/** WEBPACK FOOTER **
 ** ./www/components/home/home.component.js
 **/